<script setup>
  defineProps(['id', 'name', 'value', 'label'])

  const model = defineModel()
</script>

<template>
  <div class="form-checkbox">
    <Checkbox :id="id" v-model="model" :value="value" v-bind="$attrs" />
    <label :for="id"> {{ $te(label) ? $t(label) : label }} <slot /> </label>
  </div>
</template>

<style lang="scss" scoped>
  .form-checkbox {
    display: flex;
    align-items: center;
    gap: 10px;
  }
</style>
